// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uzfg","footer":"styles_footer__1eHzX","passCodeTooltip":"styles_passCodeTooltip__30san"};